import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { SearchRoutingModule } from './search-routing.module';
import { SearchComponent } from './search.component';
import { FormsModule } from '@angular/forms';
import { SharedModule } from '@app/shared/shared.module';
import { CardsModule } from '@app/shared/cards/cards.module';

@NgModule({
  imports: [CommonModule, FormsModule, IonicModule, SearchRoutingModule, SharedModule, CardsModule],
  declarations: [SearchComponent],
  exports: [SearchComponent]
})
export class SearchModule {}
